export function normalizeAllSpacesAccentsSpecialCharacter(value) {
    value = value || ''
    const regexAllSpaces = /\s/g
    const regexAllAccents = /[\u0300-\u036f]/g
    const regexAllSpecialCharacters = /\W/g
    return value.normalize('NFD')
        .replace(regexAllSpaces, '')
        .replace(regexAllAccents, '')
        .replace(regexAllSpecialCharacters, '')
        .toLowerCase()
}